<template>
  <article class="slo-order-status-lookup">
    <h2>{{ 'Check your order status' | t }}</h2>
    <p class="mt-sm">
      {{ 'Check on the status of your order, even if you have not registered for an account. Simply fill out the details from an existing order below.' | t }}
    </p>
    <form
      @submit.prevent="handleSubmit"
      action="#"
      class="slo-order-status-lookup--form w-100 mt-lg"
    >
      <SloField>
        <SloLabel>{{ 'Order Number' | t }}</SloLabel>
        <SloInput name="code" v-model="code" type="text" required />
      </SloField>
      <SloField>
        <SloLabel>{{ 'Order Email' | t }}</SloLabel>
        <SloInput name="email" v-model="email" type="email" inputmode="email" required />
      </SloField>
      <SloField>
        <SloLabel>{{ 'Billing ZIP Code' | t }}</SloLabel>
        <SloInput name="billZip" v-model="billZip" type="text" required />
      </SloField>
      <SloButton type="submit" :disabled="loading || !code || !email || !billZip">
        <SloLoader :loading="loading" color="white" size="md">
          {{ 'Check Status' | t }}
        </SloLoader>
      </SloButton>
    </form>
  </article>
</template>

<script>
import t from '../../../js/main/i18n';
import {formatOrderNumber, handleApiErrors} from '../../main/utils';
import {marketplaceApi} from '../apis/marketplace';
import SloField from '../../../lib/components/SloField.vue';
import SloLabel from '../../../lib/components/SloLabel.vue';
import SloInput from '../../../lib/components/SloInput.vue';
import SloButton from '../../../lib/components/SloButton.vue';
import SloLoader from '../../../lib/components/SloLoader.vue';

export default {
  name: 'OrderStatusLookup',
  components: {
    SloField,
    SloLabel,
    SloInput,
    SloButton,
    SloLoader
  },
  filters: {
    t
  },
  data() {
    return {
      loading: false,
      code: '',
      email: '',
      billZip: ''
    };
  },
  computed: {
    isCodeWithOrderNumberRange() {
      const code = parseInt(this.code, 10);
      return code >= 45000000 && code <= 49999999;
    },
    codeFormattedForSubmission() {
      return `00${formatOrderNumber(this.code)}`;
    }
  },
  watch: {
    code(newValue) {
      if (newValue) this.code = this.code.trim();
    }
  },
  methods: {
    async handleSubmit() {
      this.loading = true;


      if (this.isCodeWithOrderNumberRange) {
        await marketplaceApi.getOrder({
          code: this.codeFormattedForSubmission,
          email: this.email,
          billZip: this.billZip
        })
          .then(async res => {
            await this.$router.push({
              name: 'marketplace-guest-order',
              query: {ordercode: res.data?.orderNumber, email: this.email, billZip: this.billZip}
            });
          })
          .catch(e => {
            this.loading = false;
            handleApiErrors(e, this, 'Error locating order details');
          });
      } else {
        await marketplaceApi.getReturn({
          code: this.codeFormattedForSubmission,
          email: this.email,
          billZip: this.billZip
        })
          .then(async res => {
            await this.$router.push({
              name: 'marketplace-guest-return',
              query: {returncode: res.data?.rma, email: this.email, billZip: this.billZip}
            });
          })
          .catch(e => {
            this.loading = false;
            handleApiErrors(e, this, 'Error locating return details');
          });
      }
    }
  }
};
</script>

<style lang="scss" scoped>
@import '../../../scss/system';

.slo-order-status-lookup {
  flex: 1;
  width: 100%;
  max-width: 464px;
  padding: 1.6rem;
  border: 1px solid #d1d5db;
  border-radius: 12px;

  @media (min-width: 767px) {
    padding: 3.2rem;
  }

  h2 {
    @include text('xl', 'strong');
  }

  &--form {
    display: flex;
    flex-direction: column;
    align-items: stretch;
    justify-content: start;
    gap: 16px;
  }
}
</style>
